// The quotation Description's drop-down (Calem, Bugify #26f12089), frontend mirror of server/src/services/qoDescOptions.ts
// — change both together. It takes the place of the box that showed the primary job's name: Calem's choices word for
// word, then Other, which opens a box for the user's own wording. The form (Peak/InvoiceForm.tsx) stores
// '<choice> - <further information>', or the choice alone; the server reads the same list to hold only the words after a
// listed choice to 43 characters and to learn which choice each service usually gets (GET /api/quotations/desc-learn).
export const QO_DESC_OTHER = 'Other';
export const QO_DESC_OPTIONS: string[] = [
  'Non IMM Extension [ Renew ]',
  'Work Permit [ Renew ]',
  'Non IMM Extension & Work Permit [ Renew ]',
  'Director [ Change ]',
  'Shareholder [ Change ]',
  'Director/Shareholder [ Change ]',
  'Address [ Change ]',
  'Activity [ Change ]',
  'Property Transaction [ Full ]',
  'Due Diligence [ ONLY ]',
  'Contract Review [ Single ]',
  'Contract Review [ Multiple ]',
  'Power of Attorney',
  'Last Will & Testament [ New ]',
  'Last Will & Testament [ Change ]',
  'Company Documents [ Update ]',
  'Rental Accommodation License [ Renew ]',
  'Swimming Pool License [ Renew ]',
  'Rental Accommodation & Swimming Pool License [ Renew ]',
  'Fitness License [ Renew ]',
  'Beauty License [ Renew ]',
  'Food License [ Renew ]',
  'Alcohol License [ Renew ]',
  'Company Stamp [ Registration ]',
  'New Company',
  'Consultation',
  QO_DESC_OTHER,
];

// The listed choice a Description starts with: the longest one that is the whole text or is followed by ' - ', the way
// the form joins the further information on. '' when none is — Other's own wording, or a Description from before the list.
export const qoDescOptionOf = (text: string): string => {
  const s = String(text || '');
  let best = '';
  for (const o of QO_DESC_OPTIONS) if (o !== QO_DESC_OTHER && o.length > best.length && (s === o || s.startsWith(`${o} - `))) best = o;
  return best;
};

// A quotation's primary job: the first service line (not a note) coded Job # 1, else the first one with the lowest Job #
// above 0 (1.a counts as 1). The drop-down learns by that line's service.
type SeqLine = { job_seq?: string | null; is_note?: boolean | number | null };
const seqTier = (v?: string | null) => { const m = /^(\d+)(?:\.[a-z]+)?$/.exec(String(v || '').trim().toLowerCase()); return m ? parseInt(m[1], 10) : 0; };
export function primaryJobOf<T extends SeqLine>(items: T[]): T | undefined {
  const lines = items.filter(it => !Number(it.is_note));
  return lines.find(it => String(it.job_seq || '').trim().toLowerCase() === '1')
    || lines.reduce<T | undefined>((low, it) => (seqTier(it.job_seq) > 0 && (!low || seqTier(it.job_seq) < seqTier(low.job_seq)) ? it : low), undefined);
}
